// extracted by mini-css-extract-plugin
export default {"skill":"Skills_skill__QlJZW","logo":"Skills_logo__YMt7E","mainSkills":"Skills_mainSkills__dLlgE"};